import { WoodenRack } from '~/components/Landing/WoodenRack'

export default function WoodenRackPage() {
  return <WoodenRack />
}
